/**
 * Employee Incident Register Service
 * HTTP operations for employee incident registration
 */
import { apiClient, API_CONFIG } from '@/api/core';
import type { ApiResponse } from '@/api/shared';
import type { LC_RegisterEmployeeIncidentOut, RegisterIncidentInput, RegisterIncidentResult } from '../types';
import { mapRegisterIncidentInput, mapRegisterIncidentOutput } from '../mappers';

/**
 * Service for employee incident registration operations
 */
export class EmployeeIncidentRegisterService {
  /**
   * Register a new employee incident
   * POST /v{version}/employees/{employeeId}/attendances/incidents
   */
  async register(input: RegisterIncidentInput): Promise<ApiResponse<RegisterIncidentResult>> {
    const endpoint = API_CONFIG.ENDPOINTS.EMPLOYEE_INCIDENTS.REGISTER(input.employeeId);
    const dto = mapRegisterIncidentInput(input);
    const response = await apiClient.post<LC_RegisterEmployeeIncidentOut>(endpoint, dto);

    if (!response.success || !response.data) {
      return { ...response, data: null };
    }

    const result = mapRegisterIncidentOutput(response.data);
    return { ...response, data: result };
  }
}

export const employeeIncidentRegisterService = new EmployeeIncidentRegisterService();
